import React from "react";
import { Button } from "antd";

/** Outline button: transparent fill; border/text use primary fill; hover fills with primary fill and text uses primary.label color. */
function outlineStyleFromPrimary(primary) {
  const p = primary ?? {};
  const fill = p.backgroundColor ?? "#21ba45";
  const label = p.color ?? "#fff";
  return {
    backgroundColor: "transparent",
    borderColor: fill,
    color: fill,
    hoverBgColor: fill,
    hoverBorderColor: fill,
    hoverColor: label,
  };
}

const CustomButton = ({ type = "primary", addClass, customRef, buttonStyle, customStyle, children, ...props }) => {
  const defaultStyles = {
    primary: {
      backgroundColor: "#21ba45",
      borderColor: "#44bd60",
      color: "#fff",
      hoverBgColor: "#16ab39",
      hoverBorderColor: "#44bd60",
      hoverColor: "#fff",
    },
    link: {
      linkColor: "#1890ff",
      hoverLinkColor: "#40a9ff",
    },
  };

  const theme = buttonStyle ?? customStyle;

  if (type === "link") {
    let style = defaultStyles.link;
    if (theme?.link) style = theme.link;
    return (
      <div
        style={{
          "--button-link-color": style.linkColor,
          "--button-hover-link-color": style.hoverLinkColor,
        }}
      >
        <style>
          {`
            .salespark-custom-link-button {
              color: var(--button-link-color) !important;
            }
            .salespark-custom-link-button:hover {
              color: var(--button-hover-link-color) !important;  
            }
          `}
        </style>
        <Button type="link" ref={customRef} className={`${addClass} salespark-custom-link-button`} {...props}>
          {children}
        </Button>
      </div>
    );
  }

  let style;
  if (type === "outline") {
    const primaryEffective = { ...defaultStyles.primary, ...(theme?.primary && typeof theme.primary === "object" ? theme.primary : {}) };
    style = outlineStyleFromPrimary(primaryEffective);
  } else {
    style = defaultStyles[type] ?? defaultStyles.primary;
    if (theme?.[type]) {
      style = theme[type];
    }
  }

  return (
    <div
      style={{
        "--button-bg": style.backgroundColor,
        "--button-border": style.borderColor,
        "--button-color": style.color,
        "--button-hover-bg": style.hoverBgColor,
        "--button-hover-border": style.hoverBorderColor,
        "--button-hover-color": style.hoverColor,
      }}
    >
      <style>
        {`
          .salespark-custom-button {
            padding-left: 22px !important;
            padding-right: 22px !important;
            border-radius: var(--sp-radius-button) !important;
            font-weight: 600 !important;
            letter-spacing: 0.2px;
            background-color: var(--button-bg) !important;
            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(0, 0, 0, 0.05)) !important;
            border-color: var(--button-border) !important;
            color: var(--button-color) !important;
            box-shadow: 0 4px 14px -5px rgba(0, 0, 0, 0.18) !important;
            box-shadow: 0 4px 14px -5px color-mix(in srgb, var(--button-bg) 60%, transparent) !important;
            transition: transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1),
              box-shadow 0.25s ease, background-color 0.2s ease, border-color 0.2s ease,
              font-size 0.2s ease !important;
          }
          .salespark-custom-button:hover {
            background-color: var(--button-hover-bg) !important;
            border-color: var(--button-hover-border) !important;
            color: var(--button-hover-color) !important;
            transform: translateY(-2px) !important;
            box-shadow: 0 10px 24px -8px rgba(0, 0, 0, 0.22) !important;
            box-shadow: 0 10px 24px -8px color-mix(in srgb, var(--button-hover-bg) 65%, transparent) !important;
          }
          .salespark-custom-button:active {
            transform: translateY(0) !important;
            box-shadow: 0 3px 10px -6px rgba(0, 0, 0, 0.2) !important;
            box-shadow: 0 3px 10px -6px color-mix(in srgb, var(--button-hover-bg) 55%, transparent) !important;
          }
          .salespark-custom-button:focus-visible {
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12), 0 10px 24px -8px rgba(0, 0, 0, 0.22) !important;
            box-shadow: 0 0 0 3px color-mix(in srgb, var(--button-bg) 28%, transparent),
              0 10px 24px -8px color-mix(in srgb, var(--button-bg) 55%, transparent) !important;
          }
          .salespark-custom-button[disabled],
          .salespark-custom-button[disabled]:hover {
            opacity: 0.55 !important;
            transform: none !important;
            box-shadow: none !important;
          }
          .salespark-custom-button::selection {
            background-color: var(--button-bg) !important;
          }
        `}
      </style>
      <Button ref={customRef} className={`${addClass} salespark-custom-button submit-button`} {...props}>
        {children}
      </Button>
    </div>
  );
};

export default CustomButton;
